// extracted by mini-css-extract-plugin
export default {"skill_card":"SkillCard_skill_card__x-Kb9","icon":"SkillCard_icon__GEtBx","description":"SkillCard_description__e1aZR"};